import React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import pic1 from '../../assets/svod/user1.png';
import pic2 from '../../assets/svod/user2.png';
import pic3 from '../../assets/svod/user3.png';
import pic4 from '../../assets/svod/user4.png';
import { connect } from 'react-redux';
import { removeDropdown, updateWatchlist, toggleVolume, removeActiveVideo } from '../../redux/actions/SVOD';
import VideoPlayer from './video-player';
import NavigationBar from './navigation-bar';
import { EnvType } from "./constants";

import SVODStatus from '../../analytics/analytics-events/SVODStatus';
import { SVODStatusEvent } from '../../analytics/analytics-events/constants';
import svodMessages from '../../locales/svod';

class AssetDetailsDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.video = this.props.video;
		this.upVolume = this.upVolume.bind(this);
		this.downVolume = this.downVolume.bind(this);
		this.state = {
			active: true,
			page: "overview",
			commented: false,
			rating: "",
			imageLoaded: false,
		};

		this.backgroundFadeInterval = {};

		this.handleClose = this.handleClose.bind(this);
		this.updateWatchlist = this.updateWatchlist.bind(this);
		this.videoEnded = this.videoEnded.bind(this);
		this.changeCurrentToOverview = this.changeCurrentToOverview.bind(this);
		this.changeCurrentToComments = this.changeCurrentToComments.bind(this);
		this.changeCurrentToDetails = this.changeCurrentToDetails.bind(this);
		this.upRate = this.upRate.bind(this);
		this.downRate = this.downRate.bind(this);
		this.submitComment = this.submitComment.bind(this);
		this.triggerReport = this.triggerReport.bind(this);
		this.removeErrorMessage = this.removeErrorMessage.bind(this);
		this.detectKeypress = this.detectKeypress.bind(this);
		this.setImageFadeInInterval = this.setImageFadeInInterval.bind(this);
	}
		
	componentDidMount() {
		this.props.loadAssetComments(this.props.video._id);

		/* Google analytics event - initial opening of dropdown */
		let svodStatus = new SVODStatus(SVODStatusEvent.SHOWDETAILS_DISPLAY, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'init-open';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		let dropdown = document.getElementById("active-dropdown-scroll");
		dropdown.scrollIntoView({
			behavior: "smooth",
			block: "end"
		});

		this.setImageFadeInInterval();
	}

	setImageFadeInInterval() {
		this.backgroundFadeInterval = setInterval(() => {
			if (!this.state.imageLoaded) {
				let splashImg = document.getElementById("asset_details_dropdown-img");
				if (splashImg.complete) {
					splashImg.style.opacity = 1;
					this.setState({ imageLoaded: true });
				}
			}
		}, 500);
	}

	componentWillUnmount() {
		this.props.eventHandler({ data: { event_type: "closed_dropdown", type: "asset_details_dropdown", action: "closed_dropdown", asset_id: this.props.video._id.valueOf(), time: Date.now() } });
		if (this.backgroundFadeInterval) {
			clearInterval(this.backgroundFadeInterval);
		}
	}
	
	componentDidUpdate(prevProps, prevState) {
		if (!prevState.imageLoaded && this.state.imageLoaded) {
			clearInterval(this.backgroundFadeInterval);
		}

		if (prevState.page === "comments" && this.state.page !== "comments") {
			/* Google analytics event - leave comment page in dropdown */
			let svodStatus = new SVODStatus(SVODStatusEvent.SHOWDETAILS_COMMENTS, '', '', false, false, true, false);
			svodStatus.gaTracker = this.props.tracker;
			svodStatus.state = this.state;
			svodStatus.label = 'close';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
		}
		
		if (prevState.page === "details" && this.state.page !== "details") {
			/* Google analytics event - leave details page */
			let svodStatus = new SVODStatus(SVODStatusEvent.SHOWDETAILS_MOREDETAILS, '', '', false, false, true, false);
			svodStatus.gaTracker = this.props.tracker;
			svodStatus.state = this.state;
			svodStatus.label = 'close';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
		}

		if (this.video !== this.props.video) {
			this.props.eventHandler({ data: { event_type: "time_interacted_with", type: "asset_details_dropdown", action: "switched_dropdown", asset_id: this.video._id.valueOf(), time: Date.now() } });
			this.setImageFadeInInterval();

			/* Google analytics event - dropdown display opened for new asset */
			let svodStatus = new SVODStatus(SVODStatusEvent.SHOWDETAILS_DISPLAY, '', '', false, false, true, false);
			svodStatus.gaTracker = this.props.tracker;
			svodStatus.state = this.state;
			svodStatus.label = 'open';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

			this.video = this.props.video;
			if (this.state.active && this.videoElement !== undefined) {
				this.videoElement.updateVideoPlayer("changeVideo", true, this.props.video);
			}
			
			this.setState({
				active: true,
				page: "overview",
				commented: false,
				imageLoaded: false,
			});

			/* Google analytics event - API Call for Comments */
			svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_COMMENTSDATA, '', '', false, false, true, false);
			svodStatus.gaTracker = this.props.tracker;
			svodStatus.state = this.state;
			svodStatus.label = 'init';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

			this.props.loadAssetComments(this.props.video._id);

			let newCurr = document.getElementById("overview");
			let curr = document.getElementsByClassName("current")[0];
			curr.classList.remove("current");
			newCurr.classList.add("current");
			
		}

		if (this.state.page === "comments") {
			/* Google analytics event - opening comments page in dropdown */
			let svodStatus = new SVODStatus(SVODStatusEvent.SHOWDETAILS_COMMENTS, '', '', false, false, true, false);
			svodStatus.gaTracker = this.props.tracker;
			svodStatus.state = this.state;
			svodStatus.label = 'open';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
		}
		
		if (this.state.page === "details") {
			/* Google analytics event - opening details page in dropdown*/
			let svodStatus = new SVODStatus(SVODStatusEvent.SHOWDETAILS_MOREDETAILS, '', '', false, false, true, false);
			svodStatus.gaTracker = this.props.tracker;
			svodStatus.state = this.state;
			svodStatus.label = 'open';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
		}
	}

	videoEnded() {
		this.setState({ active: false });
	}

	upVolume() {
		/* Google analytics event - Global Mute Status */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_MUTE, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'FALSE';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
		
		this.videoElement.updateVideoPlayer("volume", true);
		this.props.toggleVolume(true);
	}

	downVolume() {
		/* Google analytics event - Global Mute Status */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_MUTE, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'TRUE';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		this.videoElement.updateVideoPlayer("volume", false);
		this.props.toggleVolume(false);
	}

	updateWatchlist() {

		if (this.props.watchlist.includes(this.props.video._id.valueOf())) {
			this.props.eventHandler({ data: { event_type: "watchlist", type: "asset_details_dropdown", action: "removed_from_watchlist", asset_id: this.props.video._id.valueOf(), time: Date.now() } });
			let newWatchlist = this.props.watchlist.filter((value) => { return value !== this.props.video._id.valueOf(); });
			this.props.updateWatchlist(newWatchlist);
		} else {
			this.props.eventHandler({ data: { event_type: "watchlist", type: "asset_details_dropdown", action: "added_to_watchlist", asset_id: this.props.video._id.valueOf(), time: Date.now() } });
			let newWatchlist = [...this.props.watchlist, this.props.video._id.valueOf()];
			this.props.updateWatchlist(newWatchlist);
		}
	}

	upRate() {
		this.props.eventHandler({ data: { event_type: "rating", type: "asset_details_dropdown", action: "like", asset_id: this.props.video._id.valueOf(), time: Date.now() } });

		let buttons = document.getElementsByClassName("dropdown-buttons-rating");
		if (buttons[1].classList.contains("selected-red")) {
			buttons[1].classList.remove("selected-red");
		}
		buttons[0].classList.add("selected-green");
		this.setState({rating: 1});
	}

	downRate() {
		this.props.eventHandler({ data: { event_type: "rating", type: "asset_details_dropdown", action: "dislike", asset_id: this.props.video._id.valueOf(), time: Date.now() } });
		let buttons = document.getElementsByClassName("dropdown-buttons-rating");
		if (buttons[0].classList.contains("selected-green")) {
			buttons[0].classList.remove("selected-green");
		}
		buttons[1].classList.add("selected-red");
		this.setState({ rating: 0 });
	}

	submitComment(event) {
		event.preventDefault();
		
		if (document.getElementById("form-textarea").value === "" || this.state.rating === "") {
			// code to trigger comment-error showing / fade away after ~6 seconds
			document.getElementById("comment-error").style.opacity = "1";
			this.removeErrorMessage();
		} else {
			let username = (document.getElementById("form-name-input").value);
			if (username === "") {
				username = "anonymous";
			}

			const commentData = {
				asset_id: this.props.video._id,
				text: document.getElementById("form-textarea").value,
				username: username,
				rating: this.state.rating,
				profilePictureNumber: this.props.profilePictureNumber,
				timecode: Date.now(),
			};

			this.props.eventHandler(
				{ data: 
					{ 
						event_type: "commented", type: "asset_details_dropdown", action: "submit_comment", asset_id: this.props.video._id.valueOf(), comment_data: commentData, time: Date.now() 
					} 
				});

			/* Google analytics event */
			let svodStatus = new SVODStatus(SVODStatusEvent.SHOWDETAILS_COMMENTS, '', '', false, false, true, false);
			svodStatus.gaTracker = this.props.tracker;
			svodStatus.state = this.state;
			svodStatus.label = 'post';
			svodStatus.data = commentData;
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

			this.props.createViewerComment(commentData);
			this.setState({ commented: true });
		}
	}

	removeErrorMessage() {
		setTimeout(function () {
			document.getElementById("comment-error").style.opacity = "0";
		}, 6000);

	}

	detectKeypress(e) {

		if (e.keyCode === 36) {
			e.preventDefault();
			let top = document.getElementById("top");
			top.scrollIntoView({
				behavior: "smooth",
				block: "end"
			});
		} else if (e.keyCode === 35) {
			e.preventDefault();
			let footer = document.getElementById("end");
			footer.scrollIntoView({
				behavior: "smooth",
				block: "end"
			});
		}
	}

	changeCurrentToOverview() {
		let newCurr = document.getElementById("overview");
		let curr = document.getElementsByClassName("current")[0];
		curr.classList.remove("current");
		newCurr.classList.add("current");

		this.setState({ page: "overview", active: true });
	}

	changeCurrentToComments() {
		let newCurr = document.getElementById("comments");
		let curr = document.getElementsByClassName("current")[0];
		curr.classList.remove("current");
		newCurr.classList.add("current");

		this.setState({ page: "comments", active: false });
	}

	changeCurrentToDetails() {
		let newCurr = document.getElementById("details");
		let curr = document.getElementsByClassName("current")[0];
		curr.classList.remove("current");
		newCurr.classList.add("current");

		this.setState({ page: "details", active: false });
	}

	handleClose() {
		this.props.eventHandler({ data: { event_type: "closed_dropdown", type: "asset_details_dropdown", action: "closed_dropdown", asset_id: this.props.video._id.valueOf(), time: Date.now() } });
		let oldSelected = document.getElementsByClassName("selected-vid")[0];
		if (oldSelected !== undefined) {
			oldSelected.classList.remove("selected-vid");
		}
		
		this.props.removeDropdown();

		/* Google analytics event */
		let svodStatus = new SVODStatus(SVODStatusEvent.SHOWDETAILS_DISPLAY, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'close';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
		
		this.props.removeActiveVideo();
	}

	triggerReport() {
		this.props.eventHandler({ data: { event_type: "asset_fullscreen_playback", type: "asset_details_dropdown", action: "asset_fullscreen_playback", asset_id: this.props.video._id.valueOf(), time: Date.now() } });
	}

	render() {
		let volumeButton = (this.state.active && this.props.activeVideo === "dropdown") ? (
			(this.props.volume.volume) ? (
				<button className="volume-btn" id="dropdown-volume" onClick={this.downVolume}><i className="fas fa-volume-up"></i></button>
			) : (
				<button className="volume-btn" id="dropdown-volume" onClick={this.upVolume}><i className="fas fa-volume-off"></i></button>
			)
		) : (
			<span></span>

		);

		let watchlistButton = (this.props.watchlist.includes(this.props.video._id.valueOf())) ? (
			<button onClick={this.updateWatchlist} className="display-button mylist" id={`watchlist-${this.props.video._id.valueOf()}`}>
				<i className="fas fa-check" /> 
				{this.props.intl.formatMessage(svodMessages.added_to_watchlist)}
			</button>
		) : (
			<button onClick={this.updateWatchlist} className="display-button mylist" id={`watchlist-${this.props.video._id.valueOf()}`}>
				<i className="fas fa-plus" /> 
				{this.props.intl.formatMessage(svodMessages.my_list)}
			</button>
		);


		let content = (this.state.active && !this.props.isSurveyActive && this.props.activeVideo === "dropdown") ? (
			<VideoPlayer location="DETAILSVIDEO" id="display-video" videoEnded={this.videoEnded} onRef={ref => this.videoElement = ref} video={this.props.video} watchpage={false} {...this.props} />
		) : (
			<img className="splash-img" id={`asset_details_dropdown-img`} src={this.props.video.images.thumbnail} alt="" />
		);

		let title = (this.props.video.images.title_image === undefined) ? (
			<p className="title">{this.props.video.content.title}</p>
		) : (
			<p className="title">
				<img src={this.props.video.images.title_image} alt="" />
			</p>
		);

		let genres = this.props.video.content.genres ? (
			this.props.video.content.genres.map((genre, idx) => {
				return (
					<li className="details-genre" key={`details-genres-${this.props.video._id}`}>{genre}</li>
				);
			})
		) : [];


		let comments = (this.props.currentAssetComments.length > 0) ? (
			this.props.currentAssetComments.map((commentObj) => {
				let rated = (commentObj.rating === 1) ? (
					<span className="comment-rating-up"><i className="fas fa-thumbs-up"></i></span>
				) : (
					<span className="comment-rating-down"><i className="fas fa-thumbs-down"></i></span>
				);

				let pictureSource = pic1;
				if (commentObj.profilePictureNumber === 2) pictureSource = pic2;
				if (commentObj.profilePictureNumber === 3) pictureSource = pic3;
				if (commentObj.profilePictureNumber === 4) pictureSource = pic4;

				if (this.props.environment === EnvType.NETFLIX) {
					return (
						<li className="comment-item" key={`comments`}>
							<span className="comment-user-info">
								<img className="user-pic comment-pic" src={pictureSource} ></img>
								{rated}
							</span>
							<span className="comment-name-text">
								<p className="comment-name">{commentObj.username}</p>
								<p className="comment-text">{commentObj.text}</p>

							</span>
						</li>
					);
				} else {
					return (
						<li className="comment-item" key={`comments`}>
							<span className="comment-user-info">
								<img className="user-pic comment-pic" src={pictureSource} ></img>
								{rated}
								<p>{commentObj.username}</p>
							</span>
							<p className="comment-text">{commentObj.text}</p>
						</li>
					);
				}
			}) 
		): (
			<div className="no-comments-div">
				{this.props.intl.formatMessage(svodMessages.first_to_leave_comment)}
			</div>
		);

		let comment_form = (this.state.commented) ? (
			<div className="commented-background">
				{this.props.intl.formatMessage(svodMessages.thank_you_for_comment)}
			</div>
		) : (
			<div className="comment-form">
				<form className='width-100p' onSubmit={this.submitComment}>
					<p className="comment-title">
						{this.props.intl.formatMessage(svodMessages.join_the_conversation)}
					</p>

					<div className="comment-rating">
						<span>
							{this.props.intl.formatMessage(svodMessages.rate_video)}
						</span>
						<button onClick={this.upRate} className="dropdown-buttons-rating"><i className="fas fa-thumbs-up"></i></button>
						<button onClick={this.downRate} className="dropdown-buttons-rating"><i className="fas fa-thumbs-down"></i></button>
					</div>

					<label id="form-label">{this.props.intl.formatMessage(svodMessages.your_name_optional)}</label>
					<input type="text" id="form-name-input" />

					<label id="form-label">{this.props.intl.formatMessage(svodMessages.write_comment_or_review)}</label>
					<textarea id="form-textarea"
						name="comment"
						onKeyDown={this.detectKeypress}
						rows="2"
					/>
					<div className="comment-buttons">
						<span id="comment-error">{this.props.intl.formatMessage(svodMessages.leave_a_comment_and_rating)}</span>
						<button onClick={this.submitComment} 
							type='submit'
							className="comment-submit-button">
							{this.props.intl.formatMessage(svodMessages.write_review)}
						</button>
					</div>
				</form>
			</div>
			
		);

		let season = (this.props.video.season_num) ? (
			<span className="title">{this.props.intl.formatMessage(svodMessages.season)}: {this.props.video.season_num}</span>
		) : (<span></span>);
		let episode = (this.props.video.episode_num) ? (
			<span className="title">{this.props.intl.formatMessage(svodMessages.episode)}: {this.props.video.episode_num}</span>
		) : (<span></span>);
		let length = (this.props.video.video.duration) ? (
			<span>{this.props.intl.formatMessage(svodMessages.length)}: {this.props.video.video.duration}m</span>
		) : (<span></span>);
		let year = (this.props.video.content.year) ? (
			<span>{this.props.video.content.year}</span>
		) : (<span></span>);
		let rated = (this.props.video.rating) ? (
			<span className="match">{this.props.intl.formatMessage(svodMessages.rating)}: {this.props.video.rating * 100}%</span>
		) : (<span></span>);
		let mpaa = (this.props.video.content.mpaa !== undefined) ? (
			<span className="rating">{this.props.video.content.mpaa.label} </span>
		) : (<span></span>);

		let background = (this.props.environment === EnvType.NETFLIX) ? (
			(this.state.page === "overview") ? (
				<div className="background">
					<div className="left">
						<h2>{title}</h2>
						<p className="metaheader">
							{rated}
							{year}
							{mpaa}
						</p>
						<p className="synopsis">{this.props.video.content.description}</p>
						<div className="display-buttons">
							<Link to="/study/watch" onClick={this.triggerReport}>
								<button className="display-button play"><i className="fas fa-play" /> {this.props.intl.formatMessage(svodMessages.play_upper)}</button>
							</Link>
							{watchlistButton}
							<button onClick={this.upRate} className="dropdown-buttons-rating"><i className="fas fa-thumbs-up"></i></button>
							<button onClick={this.downRate} className="dropdown-buttons-rating"><i className="fas fa-thumbs-down"></i></button>

						</div>
						<div className="lists">
							{length}
							<div>
								{season}
								{episode}
							</div>

						</div>

					</div>
					<div className="right">
						{content}
						{volumeButton}
					</div>
					<button className="exit" onClick={this.handleClose}>X</button>
				</div>
			) : ((this.state.page === "comments") ? (
				(this.state.commented) ? (
					<div className="background">
						<div className="commented-background">
							<p>{this.props.intl.formatMessage(svodMessages.thank_you_for_comment)}</p>
						</div>
						<button className="exit" onClick={this.handleClose}>X</button>
					</div>
				) : (
					<div className="background">
						<div className="comments-left">
							<ul className="comments-list">
								{comments}
							</ul>
						</div>

						<div className="comments-right">
							<form className='width-100p' onSubmit={this.submitComment}>
								<div className="comments-form">
									<p className="comment-title">{this.props.intl.formatMessage(svodMessages.join_the_conversation)}</p>

									<div className="comment-rating">
										<span>{this.props.intl.formatMessage(svodMessages.rate_video)}:</span>
										<span className="dropdown-ratings-span">
											<button onClick={this.upRate} className="dropdown-buttons-rating"><i className="fas fa-thumbs-up"></i></button>
											<button onClick={this.downRate} className="dropdown-buttons-rating"><i className="fas fa-thumbs-down"></i></button>
										</span>
									</div>

									<label id="form-label">{this.props.intl.formatMessage(svodMessages.your_name_optional)}</label>
									<input type="text" id="form-name-input" />
									
									<label id="form-label">{this.props.intl.formatMessage(svodMessages.write_comment_or_review)}</label>
									<textarea id="form-textarea"
										name="comment"
										onKeyDown={this.detectKeypress}
										rows="2"
									/>

									<div className="comment-buttons">
										<span id="comment-error">{this.props.intl.formatMessage(svodMessages.leave_a_comment_and_rating)}</span>
										<button className="comment-submit-button"
											type='submit'
											onClick={this.submitComment}>
											{this.props.intl.formatMessage(svodMessages.submit_upper)}
										</button>
									</div>
								</div>
							</form>
						</div>

						<button className="exit" onClick={this.handleClose}>X</button>
					</div>
				)
			) : (
				<div className="background">
					<div className="details-page">
						<p className="details-title">{title}</p>

						<div className="details-info">
							<div className="details-left">
								<p className="details-header">{this.props.intl.formatMessage(svodMessages.genres)}</p>
								<ul>
									{genres}
								</ul>
							</div>
							<div className="details-right">
								<div className="details-header">{this.props.intl.formatMessage(svodMessages.maturity_ratings)}</div>
								<span>{mpaa}</span>

							</div>
						</div>

					</div>
					<button className="exit" onClick={this.handleClose}>X</button>
				</div>
			))
		) : (
			<div className="details-screen-content">
				<NavigationBar {...this.props} environment={this.props.environment} closeDropdown={this.handleClose}/>

				<div className="details-meta">
					<img className="details-img" id={`asset_details_dropdown-img`} src={this.props.video.images.thumbnail} alt="" />

					<div className="details-meta-data">
						<h2>{title}</h2>
						<p className="metaheader">
							{rated}
							{length}
							{year}
							{mpaa}
						</p>
						<p className="synopsis">{this.props.video.content.description}</p>
						<div className="details-screen-buttons">
							{watchlistButton}
							<Link to="/study/watch" onClick={this.triggerReport}>
								<button className="display-button play"><i className="fas fa-play" /> {this.props.intl.formatMessage(svodMessages.watch_now)}</button>
							</Link>
						</div>
					</div>
				</div>

				<div className="details-comments">

					{comment_form}

					<div className="comments-right">
						<h5>{this.props.intl.formatMessage(svodMessages.reviews)}</h5>
						<ul className="comment-list">
							{comments}
						</ul>
					</div>

				</div>

			</div>
		);

		let dropdown_screen_buttons = (this.props.environment === EnvType.NETFLIX) ? (
			(this.props.video.display_type === "billboard") ? (
				<div className="dropdown-screen-buttons">
					<div onClick={this.changeCurrentToOverview} className="current" id="overview">
						{this.props.intl.formatMessage(svodMessages.overview_upper)}
						<span></span>
					</div>
				</div>
			) : (
				<div className="dropdown-screen-buttons">
					<div onClick={this.changeCurrentToOverview} className="current" id="overview">
						{this.props.intl.formatMessage(svodMessages.overview_upper)}
						<span></span>
					</div>
					<div onClick={this.changeCurrentToComments} id="comments">
						{this.props.intl.formatMessage(svodMessages.comments_reviews_upper)}
						<span></span>
					</div>
					<div onClick={this.changeCurrentToDetails} id="details">
						{this.props.intl.formatMessage(svodMessages.details_upper)}
						<span></span>
					</div>
				</div>
			)
		) : (
			<span></span>
		);

		
		return (
			<div className="content" id="active-dropdown-scroll">

				{background}
				{dropdown_screen_buttons}
			
			</div>
		);
	}
}



const mapStateToProps = (state) => ({
	video: state.SVOD.dropdown.video,
	activeVideo: state.SVOD.activeVideo,
	watchlist: state.SVOD.watchlist,
	volume: state.SVOD.volume,
	profilePictureNumber: state.SVOD.profilePictureNumber,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	environment: state.SVOD.environment,
	isSurveyActive: state.SVOD.isSurveyActive
});


const mapDispatchToProps = (dispatch) => ({
	removeDropdown: () => dispatch(removeDropdown()),
	updateWatchlist: (newWatchlist) => dispatch(updateWatchlist(newWatchlist)),
	toggleVolume: (volume) => dispatch(toggleVolume(volume)),
	removeActiveVideo: () => dispatch(removeActiveVideo()),
});

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(injectIntl(AssetDetailsDropdown));


// WEBPACK FOOTER //
// ./src/components/svod/asset-details-dropdown.jsx